import {Auth} from 'aws-amplify';

import AdminBase from '../views/Admin/Layout.vue';
import Dashboard from '../views/Admin/Dashboard.vue';
import Moderators from '@/views/Admin/Moderators/List.vue';
import Animals from '@/views/Admin/Animals/List.vue';
import Animal from '@/views/Admin/Animals/Details.vue';
import Posts from '@/views/Admin/Posts/List.vue';
import Users from '@/views/Admin/Users/List.vue';
import UserDetails from '@/views/Admin/Users/Details.vue';

function mustBeAdmin(to: any, from: any, next: any) {
  Auth.currentAuthenticatedUser().then((user) => {
    const role = user.signInUserSession.idToken.payload['cognito:groups'][0];
    if (role === 'Admin') {
      next();
    } else if (role === 'Moderator') {
      next({name: 'ModeratorBase'});
    } else {
      next({name: 'UserBase'});
    }
  }).catch(() => {
    next({name: 'GuestBase'});
  });
}

export default [
  {
    path: '/admin',
    name: 'AdminBase',
    component: () => import(/* webpackChunkName: "AdminBase" */ '../views/Admin/Layout.vue'),
    beforeEnter: mustBeAdmin,
    redirect: {name: 'AdminDashboard'},
    children: [
      {
        path: 'dashboard',
        name: 'AdminDashboard',
        component: Dashboard,
      },
      {
        path: 'moderators',
        name: 'AdminModerators',
        component: Moderators,
      },
      {
        path: 'animals',
        name: 'AdminAnimals',
        component: Animals,
      },
      {
        path: 'animal/:id',
        props: true,
        name: 'AdminAnimal',
        component: Animal,
      },
      {
        path: 'posts',
        name: 'AdminPosts',
        component: Posts,
      },
      {
        path: 'users',
        name: 'AdminUsers',
        component: Users,
      },
      {
        path: 'users/:id',
        props: true,
        name: 'AdminUser',
        component: UserDetails,
      },
    ],
  },
];
